import { createFeatureSelector } from '@ngrx/store';
import { AdminState } from 'src/app/admin/store/admin.state';

export const AdminFeatureKey = 'admin';

export const selectFeature = createFeatureSelector<AdminState>(AdminFeatureKey);
